import { FormControl, FormHelperText, OutlinedInput } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

export default function TextInputField({
  label,
  placeholder,
  value,
  onChange,
  className = "w-full",
}) {
  return (
    <FormControl className={className}>
      <FormHelperText className="m-0 pb-2 text-base font-semibold">{label}:</FormHelperText>
      <OutlinedInput
        placeholder={placeholder}
        className="rounded-[8px]"
        value={value}
        onChange={onChange}
        notched
        sx={{
          "&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1 px",
            borderColor: HNSColors.neutrals[500],
          },
          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1 px",
            borderColor: HNSColors.neutrals[400],
          },
          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1 px",
            borderColor: HNSColors.neutrals[400],
          },
        }}
      />
    </FormControl>
  );
}
